import { getMenuAuth } from "src/apis/authApi";
import {  useCallback, useEffect } from "react";
import {  getPRD4060_R01List, getPRD4060_R01AllCount, exportPRD4060_R01Excel } from "./Api_PRD4060_R01"
import useActionbarAuthStore from "src/store/useActionbarAuthStore";
import useMenuGlobalStore from "src/store/useMenuStore";
import { downloadSettingExcel } from "src/utils/blob/blobUtil";
import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";
import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
import { ShowSuccessFetch, showWarning } from "src/utils/toast/toastUtil";

import { usePRD4060_R01Store, defaultPRD4060_R01Filter, PRD4060_R01Filter } from "./Store_PRD4060_R01";
import { PRD4060_R01Dto } from "./Dto_PRD4060_R01";
import { fetchDataSetHandler, fetchFilterConfig } from "src/utils/grid/GridHandlerContent";
import { formatDate } from "src/utils/string/stringUtil";

interface ProductResultContentProps {
    setMessage: (message: string) => void;
}

export const Content_PRD4060_R01 = (props: ProductResultContentProps) => {
    const { setMessage } = props;

    const { 
        PRD4060_R01Filter, setPRD4060_R01Filter,
        PRD4060_R01PastFilter, setPRD4060_R01PastFilter,
        PRD4060_R01List, setPRD4060_R01List, 
        setAllCount,
        setScrollTop,
    } = usePRD4060_R01Store();
    const { setLoadingSpinner } = useLoadingSpinnerStore();
    const { selectedThirdMenu } = useMenuGlobalStore();
    const menuCdStore = selectedThirdMenu?.menuCd;
    const setAuth = useActionbarAuthStore((state) => state.setAuth);

    useFetchActionbarAuth("PRD4060_R01");

    useEffect(() => {
        getMenuAuth("PRD4060_R01").then((res) => {
            setAuth(res.data);
        });
    }, []);

    useEffect(() => {
        if (!menuCdStore) {
            console.log("[PRD4060_R01] menuCd가 없습니다. 메뉴를 선택하세요.");
        } else {
            console.log("[PRD4060_R01] menuCd:" + menuCdStore);
        }
    }, [menuCdStore]);

    const getParams = (filter: Partial<PRD4060_R01Filter>) => {
        return {
			compCd: filter.compCd,
			downtimeCase: filter.downtimeCase,
			dateRange: filter.dateRange,
			startDate: filter.dateRange ? formatDate(filter.dateRange.from) : undefined,
			endDate: filter.dateRange ? formatDate(filter.dateRange.to) : undefined,	
			productEmp: filter.productEmp,
			productEmpNm: filter.productEmpNm,
        };
    }

    const renewalAllCount = useCallback(async () => {
        const response = await getPRD4060_R01AllCount(getParams(PRD4060_R01Filter));
        setAllCount(response.data.data);
        return response.data.data;
    }, [PRD4060_R01Filter, setAllCount]);

    const fetchData = useCallback(async () => {
        setScrollTop(null);
        setLoadingSpinner(true);
        try {
			
            const response = await getPRD4060_R01List(
                '',
                getParams(PRD4060_R01Filter),
                PRD4060_R01List.length ?? 0
            );

            const rawData = (response.data.data as Omit<PRD4060_R01Dto, 'valueIndex'|'orderIndex'|'orderIndexSeq'>[]).map((row, idx) => ({
                valueIndex: idx,
                orderIndex: idx + 1,
                orderIndexSeq: 0,
                ...row,
            }));

			const newList = [...rawData ] as PRD4060_R01Dto[];
            const processAllCount = await renewalAllCount();

            if (newList && newList.length > 0) {
                setPRD4060_R01PastFilter(PRD4060_R01Filter);
                setPRD4060_R01List(newList);
                ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
            } else {
                showWarning('데이터가 없습니다.');
                setPRD4060_R01List([]);
            }
        } catch (error) {
            console.error('데이터 조회 실패:', error);
            showWarning('데이터 조회에 실패했습니다.');
            setPRD4060_R01List([]);
        } finally {
            setLoadingSpinner(false);
        }
    }, [PRD4060_R01Filter, setPRD4060_R01List, setPRD4060_R01PastFilter, setScrollTop]);
    
    const handleExcelClick = async () => {
        const {isDefaultFilter, isDefaultPastFilter, listLength} = fetchFilterConfig(
            PRD4060_R01Filter,
            PRD4060_R01PastFilter,
            defaultPRD4060_R01Filter,
            PRD4060_R01List.length
        );

        const response = await exportPRD4060_R01Excel(
            isDefaultFilter? '' : 'search',
            getParams(PRD4060_R01Filter),
            listLength
        );
        downloadSettingExcel({
            responseData: response.data.data,
            fileName: '비가동 조회-excel.xlsx',
        });
    };

    return {
        fetchData,
        handleExcelClick,
    };
};

